// extracted by mini-css-extract-plugin
export default {"date":"card-assessment_date__Bvspu"};